import { render, staticRenderFns } from "./Professionalization.vue?vue&type=template&id=c549cd24&scoped=true"
import script from "./Professionalization.vue?vue&type=script&lang=js"
export * from "./Professionalization.vue?vue&type=script&lang=js"
import style0 from "./Professionalization.vue?vue&type=style&index=0&id=c549cd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c549cd24",
  null
  
)

export default component.exports